import axios from '@/util/axios';

const state = {
    current: null,
    conferences: [],
};

// getters
const getters = {
    current: (state) => state.current
        ? state.conferences.filter(e => e.type == state.current.type && e.year == state.current.year)[0]
        : state.conferences[0],
    all: (state) => state.conferences.filter(e => e.visible)
}

// actions
const actions = {
    async changeCurrent({ commit }, payload) {
        commit('setCurrent', payload);
    },

    //async init({ commit }) {
    //    let conferences = (await axios.get('public/conferences')).data;
    //    console.log("Conferences from API:", conferences);
    //    var mappedData = conferences.map(function (e) {
    //        return {
    //            key: `${e.conferenceYear}-${e.conferenceType}`,
    //            type: e.conferenceType,
    //            year: e.conferenceYear,
    //            visible: e.visible,
    //            description: e.description.map(function (d) {
    //                return {
    //                    name: d.name,
    //                    topic: d.description,
    //                    date: d.description2,
    //                    logo: d.logotype,
    //                    logoImg: axios.getFileUrl(d.logotype),
    //                    logoBrightImg: axios.getFileUrl(d.logotype)
    //                }
    //            })
    //        }
    //    });
    //    commit('setConferences', mappedData);
    //}
    async init({ commit }) {
        let response = await axios.get('public/conferences');
        let conferences = response.data;
        let mappedData = conferences.map(e => {
            let descriptionMap = {};
    
            // Sprawdź, czy description istnieje i jest tablicą
            if (Array.isArray(e.description)) {
                e.description.forEach(d => {
                    // Tworzymy obiekt descriptionMap, używając d.language jako klucza
                    descriptionMap[d.language] = {
                        name: d.name || "Brak nazwy",
                        topic: d.description || "",
                        date: d.description2 || "",
                        logo: d.logotype || "",
                        logoImg: d.logotype ? axios.getFileUrl(d.logotype) : "",
                        logoBrightImg: d.logotype ? axios.getFileUrl(d.logotype) : ""
                    };
                });
            }
    
            return {
                key: `${e.conferenceYear}-${e.conferenceType}`,
                type: e.conferenceType,
                year: e.conferenceYear,
                visible: e.visible,
                description: descriptionMap  // Teraz to OBIEKT, a nie tablica
            };
        });
    
        commit('setConferences', mappedData);
    }
    
}

// mutations
const mutations = {
    resetCurrent(state) {
        state.current = { type: state.conferences[0].type, year: state.conferences[0].year }
    },
    setCurrent(state, payload) {
        state.current = payload ? { type: payload.type, year: payload.year } : null;
    },
    setConferences(state, payload) {
        state.conferences = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}